import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();

browserHistory.getCurrentLocation = () => {
    return {
        pathname: browserHistory.location.pathname,
        search: browserHistory.location.search,
        hash: browserHistory.location.hash,
        state: browserHistory.location.state,
        query: (() => {
            const queryParams = new URLSearchParams(browserHistory.location.search);
            const query = {};

            for (const [key, value] of queryParams.entries()) {
                if (query[key]) {
                    if (Array.isArray(query[key])) {
                        query[key].push(value);
                    } else {
                        query[key] = [query[key], value];
                    }
                } else {
                    query[key] = value;
                }
            }

            return query;
        })()
    };
};

export default browserHistory;
